import { Injectable } from '@angular/core';
import * as _nameDoesntMatter from 'jquery'; // eslint-disable-line

@Injectable({
    providedIn: 'root',
})
export class FroalaActionsService {
    isDragStartWithinEditor(dropEvent: any): boolean {
        let data;
        try {
            data = dropEvent.dataTransfer.getData('is-drag-within');
        } catch {
            data = dropEvent.originalEvent.dataTransfer.getData('is-drag-within');
        }
        return data === 'true';
    }

    getHtmlData(dropEvent: any): string {
        try {
            return dropEvent.dataTransfer.getData('field-merge-html');
        } catch {
            return dropEvent.originalEvent.dataTransfer.getData('field-merge-html');
        }
    }

    createNode(nodeString: string): DocumentFragment {
        const node: DocumentFragment = document.createRange().createContextualFragment(nodeString);
        const childNode: Element = node.childNodes[0] as Element;
        // browser quirks
        node.childNodes.forEach(child => {
            if (child.nodeName === 'META') {
                node.removeChild(child);
            }
        });
        const removeButton = document.createElement('button');
        const removeButtonText = document.createTextNode('x');
        removeButton.classList.add('field-merge-remove');
        if (childNode.classList.contains('tfs-field-merge')) {
            removeButton.classList.add('tfs-remove');
        } else if (childNode.classList.contains('tfs-pipedelimited-field-merge')) {
            removeButton.classList.add('tfs-pipedelimited-remove');
        } else if (childNode.classList.contains('cdo-field-merge')) {
            removeButton.classList.add('cdo-field-remove');
        } else if (childNode.classList.contains('json-field-merge')) {
            removeButton.classList.add('json-field-remove');
        } else if (childNode.classList.contains('json-array-field-merge')) {
            removeButton.classList.add('json-array-field-remove');
        }
        removeButton.appendChild(removeButtonText);
        removeButton.addEventListener('click', this.removeFieldMergeFromEditor, false);

        node.childNodes.forEach(child => {
            if (child.nodeName === 'SPAN') {
                child.appendChild(removeButton);
                child.after(document.createTextNode('\u00A0'));
            }
        });
        return node;
    }

    insertNode(target: HTMLElement, targetClassList: DOMTokenList, node: DocumentFragment) {
        if (target) {
            if (targetClassList.contains('field-merge') || targetClassList.contains('field-merge-remove')) {
                target.closest('.field-merge')?.after(node);
            } else {
                target.replaceWith(node);
            }
        }
    }

    showCursorForFirefox(editor: any) {
        editor.events.disableBlur();
        setTimeout(function () {
            editor.$el.blur().focus();
            editor.events.enableBlur();
        }, 0);
    }

    setDataOnDragEvent(dragEvent: any) {
        const dataTransferData = (dragEvent.originalEvent as JQuery.DragEvent).target.outerHTML;
        dragEvent.originalEvent.dataTransfer.setData('field-merge-html', dataTransferData);
        dragEvent.originalEvent.dataTransfer.setData('is-drag-within', 'true');
        try {
            dragEvent.originalEvent.dataTransfer.setData('text/plain', '');
        } catch (e) {
            dragEvent.originalEvent.dataTransfer.setData('text', '');
        }
    }

    adjustNodeSpacing() {
        const fieldMerges = document.querySelectorAll('.fr-element .field-merge');
        fieldMerges.forEach((fieldMerge: Element) => {
            if (fieldMerge.nextSibling) {
                this.removeTextNodesOnRight(fieldMerge.nextSibling, fieldMerge);
            }
            if (fieldMerge.previousSibling) {
                this.removeTextNodesOnLeft(fieldMerge.previousSibling);
            }
        });
        fieldMerges.forEach(fieldMerge => {
            fieldMerge.after(document.createTextNode('\u00A0'));
        });
    }

    adjustSingleNodeSpacing(nodeToUpdate: Element) {
        const nodeValue = nodeToUpdate.nextSibling!.nodeValue;
        if (nodeValue && nodeValue.charCodeAt(0) !== 32 && nodeValue.charCodeAt(0) !== 160) {
            nodeToUpdate.after(document.createTextNode('\u00A0'));
        }
    }

    removeTextNodesOnRight(node: ChildNode, fieldMerge: Element) {
        if (node && node.nodeName === '#text' && node.nodeType === 3) {
            const nextNode = node.nextSibling;
            if (node.nodeValue!.trim().length === 0) {
                node.remove();
                if (nextNode) {
                    this.removeTextNodesOnRight(nextNode, fieldMerge);
                }
            } else {
                const trimmedNode = node.nodeValue!.trim();
                node.remove();
                fieldMerge.after(document.createTextNode(trimmedNode));
                if (nextNode) {
                    this.removeTextNodesOnRight(nextNode, fieldMerge);
                }
            }
        } else {
            return false;
        }
    }

    removeTextNodesOnLeft(node: ChildNode) {
        if (node && node.nodeName === '#text' && node.nodeType === 3) {
            if (node.nodeValue && node.nodeValue.trim().length === 0) {
                const previousNode = node.previousSibling;
                node.remove();
                if (previousNode) {
                    this.removeTextNodesOnLeft(previousNode);
                }
            }
        } else {
            return false;
        }
    }

    cancelEvent(event: DragEvent | JQuery.DropEvent): boolean {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        return false;
    }

    addEventListenersToEditorContainer(dropped: any, dragEnter: any, dragOver: any) {
        const dropTargets = document.querySelectorAll('[data-role="drag-drop-target"] div.fr-view'); //there could be multiple editors in one app
        dropTargets.forEach(dropTarget => {
            dropTarget.addEventListener('drop', dropped, false);
            dropTarget.addEventListener('dragenter', dragEnter, false);
            dropTarget.addEventListener('dragover', dragOver, false);
        });
    }

    addClickEventToFieldMergeRemoveButtons() {
        const fieldMergeRemoveButtons = document.querySelectorAll('.field-merge-remove');
        fieldMergeRemoveButtons.forEach(button => {
            button.addEventListener('click', this.removeFieldMergeFromEditor, false);
        });
    }

    removeFieldMergeFromEditor(event: Event): void {
        const fieldMergeElement = (<HTMLElement>event.target).parentNode;
        const editor: HTMLElement | null = document.querySelector('.fr-element');
        if (fieldMergeElement) {
            const fieldMergeElementParent = fieldMergeElement.parentNode;
            if (fieldMergeElementParent) {
                fieldMergeElementParent.removeChild(fieldMergeElement);
            }
        }
        if (editor) {
            editor.focus();
        }
    }
}
